<div class="w-full container items-center gap-4">
  <div class="left-side">
    <div class="w-full period-type-switch">
      <div
        class="period-type-switch-button"
        [class.selected]="!pickDateFromCalendarMode && periodType === PeriodTypes.MONTH"
        (click)="onMonthTypePeriodSelect()"
      >
        <span class="paragraph-medium">{{ 'myGanarbols.month' | translate }}</span>
      </div>
      <div
        class="period-type-switch-button"
        [class.selected]="!pickDateFromCalendarMode && periodType === PeriodTypes.QUARTER"
        (click)="onQuarterTypePeriodSelect()"
      >
        <span class="paragraph-medium">{{ 'myGanarbols.quarter' | translate }}</span>
      </div>
    </div>
    <div class="calendar">
      <button nz-button nzType="text" [class.selected]="pickDateFromCalendarMode" (click)="onCalendarClick()">
        <i nz-icon>
          @if (!!pickDateFromCalendarMode) {
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M21.5 8.5V17.75C21.5 19.5449 20.0449 21 18.25 21H6.75C4.95507 21 3.5 19.5449 3.5 17.75V8.5H21.5ZM7.75 15C7.05964 15 6.5 15.5596 6.5 16.25C6.5 16.9404 7.05964 17.5 7.75 17.5C8.44036 17.5 9 16.9404 9 16.25C9 15.5596 8.44036 15 7.75 15ZM12.5 15C11.8096 15 11.25 15.5596 11.25 16.25C11.25 16.9404 11.8096 17.5 12.5 17.5C13.1904 17.5 13.75 16.9404 13.75 16.25C13.75 15.5596 13.1904 15 12.5 15ZM7.75 10.5C7.05964 10.5 6.5 11.0596 6.5 11.75C6.5 12.4404 7.05964 13 7.75 13C8.44036 13 9 12.4404 9 11.75C9 11.0596 8.44036 10.5 7.75 10.5ZM12.5 10.5C11.8096 10.5 11.25 11.0596 11.25 11.75C11.25 12.4404 11.8096 13 12.5 13C13.1904 13 13.75 12.4404 13.75 11.75C13.75 11.0596 13.1904 10.5 12.5 10.5ZM17.25 10.5C16.5596 10.5 16 11.0596 16 11.75C16 12.4404 16.5596 13 17.25 13C17.9404 13 18.5 12.4404 18.5 11.75C18.5 11.0596 17.9404 10.5 17.25 10.5ZM18.25 3C20.0449 3 21.5 4.45507 21.5 6.25V7H3.5V6.25C3.5 4.45507 4.95507 3 6.75 3H18.25Z"
                fill="#FCFCFC"
              />
            </svg>
          } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M17.75 3C19.5449 3 21 4.45507 21 6.25V17.75C21 19.5449 19.5449 21 17.75 21H6.25C4.45507 21 3 19.5449 3 17.75V6.25C3 4.45507 4.45507 3 6.25 3H17.75ZM19.5 8.5H4.5V17.75C4.5 18.7165 5.2835 19.5 6.25 19.5H17.75C18.7165 19.5 19.5 18.7165 19.5 17.75V8.5ZM7.75 14.5C8.44036 14.5 9 15.0596 9 15.75C9 16.4404 8.44036 17 7.75 17C7.05964 17 6.5 16.4404 6.5 15.75C6.5 15.0596 7.05964 14.5 7.75 14.5ZM12 14.5C12.6904 14.5 13.25 15.0596 13.25 15.75C13.25 16.4404 12.6904 17 12 17C11.3096 17 10.75 16.4404 10.75 15.75C10.75 15.0596 11.3096 14.5 12 14.5ZM7.75 10.5C8.44036 10.5 9 11.0596 9 11.75C9 12.4404 8.44036 13 7.75 13C7.05964 13 6.5 12.4404 6.5 11.75C6.5 11.0596 7.05964 10.5 7.75 10.5ZM12 10.5C12.6904 10.5 13.25 11.0596 13.25 11.75C13.25 12.4404 12.6904 13 12 13C11.3096 13 10.75 12.4404 10.75 11.75C10.75 11.0596 11.3096 10.5 12 10.5ZM16.25 10.5C16.9404 10.5 17.5 11.0596 17.5 11.75C17.5 12.4404 16.9404 13 16.25 13C15.5596 13 15 12.4404 15 11.75C15 11.0596 15.5596 10.5 16.25 10.5ZM17.75 4.5H6.25C5.2835 4.5 4.5 5.2835 4.5 6.25V7H19.5V6.25C19.5 5.2835 18.7165 4.5 17.75 4.5Z"
                fill="#7D7D99"
              />
            </svg>
          }
        </i>
      </button>
    </div>
  </div>
  <div class="w-full right-side justify-between items-center">
    @if (pickDateFromCalendarMode) {
      <div class="flex gap-4 w-full">
        <korviu-date-picker
          [control]="startDateControl"
          [disabledDate]="disableStartDate"
          label="Start Date"
          mode="date"
          class="w-full"
        ></korviu-date-picker>
        <korviu-date-picker
          [control]="endDateControl"
          [disabledDate]="disableEndDate"
          label="End Date"
          mode="date"
          class="w-full"
        ></korviu-date-picker>
      </div>
    }
    @if (!pickDateFromCalendarMode) {
      <ng-container>
        <div class="date-range-value flex justify-center w-full">
          <span class="paragraph-large bold">{{ formattedPeriod }}</span>
        </div>
        <div class="period-switch w-full justify-end">
          <div class="period-switch-button" [class.available]="prevButtonAvailable" (click)="onPrevPeriodCLick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M21.1862 11.1094H7.47288L15.6807 3.98438C15.8119 3.86953 15.7323 3.65625 15.5588 3.65625H13.4846C13.3932 3.65625 13.3065 3.68906 13.2385 3.74766L4.38148 11.4328C4.30036 11.5031 4.2353 11.5901 4.19071 11.6877C4.14612 11.7854 4.12305 11.8915 4.12305 11.9988C4.12305 12.1062 4.14612 12.2123 4.19071 12.3099C4.2353 12.4076 4.30036 12.4945 4.38148 12.5648L13.2901 20.2969C13.3252 20.3273 13.3674 20.3438 13.4119 20.3438H15.5565C15.7299 20.3438 15.8096 20.1281 15.6784 20.0156L7.47288 12.8906H21.1862C21.2893 12.8906 21.3737 12.8062 21.3737 12.7031V11.2969C21.3737 11.1937 21.2893 11.1094 21.1862 11.1094Z"
              />
            </svg>
          </div>
          <div class="period-switch-button" [class.available]="nextButtonAvailable" (click)="onNextPeriodCLick()">
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
              <path
                d="M3.81384 12.8906L17.5271 12.8906L9.31931 20.0156C9.18806 20.1305 9.26774 20.3437 9.44118 20.3437L11.5154 20.3437C11.6068 20.3437 11.6935 20.3109 11.7615 20.2523L20.6185 12.5672C20.6996 12.4969 20.7647 12.4099 20.8093 12.3123C20.8539 12.2146 20.877 12.1085 20.877 12.0012C20.877 11.8938 20.8539 11.7877 20.8093 11.6901C20.7647 11.5924 20.6996 11.5055 20.6185 11.4352L11.7099 3.70312C11.6748 3.67266 11.6326 3.65625 11.5881 3.65625L9.44353 3.65625C9.27009 3.65625 9.1904 3.87187 9.32165 3.98437L17.5271 11.1094L3.81384 11.1094C3.71071 11.1094 3.62634 11.1937 3.62634 11.2969L3.62634 12.7031C3.62634 12.8062 3.71071 12.8906 3.81384 12.8906Z"
              />
            </svg>
          </div>
        </div>
      </ng-container>
    }
  </div>
</div>
